import { useEffect, useState } from "react";
import apiClient from "../../../apiClient";
import { AttributeDataType, AttributeDefinition } from "./configTypes";
import { notify } from "../../../utils";

export interface NewAttributeDefinitionPayload {
    itemTypeId: number;
    label: string;
    dataType: AttributeDataType;
    attributeKey?: string;
    isRequired?: boolean;
    isFilterable?: boolean;
    options?: string[];
    displayOrder?: number;
}

export default function useAttributeDefinitions() {
    const [definitions, setDefinitions] = useState<AttributeDefinition[]>([]);

    const getAttributeDefinitions = async () => {
        const res = await apiClient.get(`/inventory-dev/attribute-definitions`);
        setDefinitions(res.data);
    };

    useEffect(() => {
        getAttributeDefinitions();
    }, []);

    const createAttributeDefinition = async (payload: NewAttributeDefinitionPayload) => {
        const res = await apiClient.post(`/inventory-dev/attribute-definitions`, payload);
        setDefinitions((prev) => [...prev, res.data]);
        return res.data as AttributeDefinition;
    };

    const deleteAttributeDefinition = async (id: number) => {
        const res = await apiClient.delete(`/inventory-dev/attribute-definitions/${id}`);
        const { data } = res;
        notify(`Attribute deleted: cleared ${data.clearedUnitValues} unit values`);
        setDefinitions((prev) => prev.filter((d) => d.id !== id));
    };

    return { definitions, getAttributeDefinitions, createAttributeDefinition, deleteAttributeDefinition };
}
